import { Fragment, type ReactNode } from 'react';

import { Theme as CoreTheme } from '@ovpn/ui';

import { isTrue } from '@sso/shared/utils';

import { AppWrapper } from './MFWrapper.styles';
import NavPusher from './NavPusher';

const Theme = isTrue(window._env_?.NEW_SIDEBAR) ? Fragment : CoreTheme;

function MFWrapper({ children }: { children: ReactNode }) {
    return (
        <Theme>
            <NavPusher>
                <AppWrapper>{children}</AppWrapper>
            </NavPusher>
        </Theme>
    );
}

export default MFWrapper;
